import React from 'react';
import { Tooltip } from 'react-tooltip';
import uuid from 'react-uuid';
import { Grid } from '@mui/material';
import styled from 'styled-components';
import { AccountData, OrderPageData } from '../../api';
import { getOrderPages } from '../AccountUtils';
import { getContrastColor } from './getContrastColor';

export const StyledCircle = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
`;

export const WorkshopCircle = ({
  account,
  orderPageId,
  withTooltip,
  language,
  customDetailAmoount,
}: {
  account: AccountData;
  orderPageId?: string;
  withTooltip?: boolean;
  language: 'he' | 'en';
  customDetailAmoount?: number;
}) => {
  if (!orderPageId) {
    return <StyledCircle style={{ backgroundColor: '#6577b3' }} />;
  }
  const orderPage = getOrderPages(account).find((x: OrderPageData) => x.id === orderPageId);
  const id = `tooltip-${orderPageId}-${uuid()}`;
  const backgroundColor = orderPageId
    ? getOrderPages(account).find((x: OrderPageData) => x.id === orderPageId)?.color || '#6577b3'
    : '#6577b3';

  const textColor = getContrastColor(backgroundColor);
  return (
    <>
      <Tooltip
        place="bottom"
        content={withTooltip ? orderPage?.label[language] : ''}
        id={id}
        variant="light"
        border="1px solid black"
      />

      <StyledCircle style={{ backgroundColor, position: 'relative' }} data-tooltip-id={id}>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          sx={{
            color: textColor,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            fontSize: '12px',
            fontWeight: 'bold',
          }}>
          {customDetailAmoount}
        </Grid>
      </StyledCircle>
    </>
  );
};
